import 'blur_admin/src/app/theme/theme.module';
import 'blur_admin/src/app/theme/components/components.module';
import 'blur_admin/src/app/theme/inputs/inputs.module';

import 'blur_admin/src/app/theme/theme.config';
import 'blur_admin/src/app/theme/theme.configProvider';
import 'blur_admin/src/app/theme/theme.constants';
import 'blur_admin/src/app/theme/theme.run';
import 'blur_admin/src/app/theme/theme.service';

import 'blur_admin/src/app/theme/components/toastrLibConfig';
import 'blur_admin/src/app/theme/components/backTop/backTop.directive';
import 'blur_admin/src/app/theme/components/baPanel/baPanel.directive';
import 'blur_admin/src/app/theme/components/baPanel/baPanel.service';
import 'blur_admin/src/app/theme/components/baPanel/baPanelBlur.directive';
import 'blur_admin/src/app/theme/components/baPanel/baPanelBlurHelper.service';
import 'blur_admin/src/app/theme/components/baPanel/baPanelSelf.directive';
import 'blur_admin/src/app/theme/components/baSidebar/baSidebar.directive';
import 'blur_admin/src/app/theme/components/baSidebar/baSidebar.service';
import 'blur_admin/src/app/theme/components/baSidebar/BaSidebarCtrl';
import 'blur_admin/src/app/theme/components/baSidebar/baSidebarHelpers.directive';
import 'blur_admin/src/app/theme/components/baWizard/baWizard.directive';
import 'blur_admin/src/app/theme/components/baWizard/baWizardCtrl';
import 'blur_admin/src/app/theme/components/baWizard/baWizardStep.directive';
import 'blur_admin/src/app/theme/components/contentTop/contentTop.directive';

//import 'blur_admin/src/app/theme/components/msgCenter/msgCenter.directive';
//import 'blur_admin/src/app/theme/components/msgCenter/MsgCenterCtrl';

import 'blur_admin/src/app/theme/components/pageTop/pageTop.directive';
import 'blur_admin/src/app/theme/components/progressBarRound/progressBarRound.directive';
import 'blur_admin/src/app/theme/components/widgets/widgets.directive';

//import 'blur_admin/src/app/theme/directives/animatedChange';
import 'blur_admin/src/app/theme/directives/autoExpand';
import 'blur_admin/src/app/theme/directives/autoFocus';
import 'blur_admin/src/app/theme/directives/includeWithScope';
import 'blur_admin/src/app/theme/directives/ionSlider';
import 'blur_admin/src/app/theme/directives/ngFileSelect';
import 'blur_admin/src/app/theme/directives/scrollPosition';
import 'blur_admin/src/app/theme/directives/trackWidth';
import 'blur_admin/src/app/theme/directives/zoomIn';

import 'blur_admin/src/app/theme/filters/image/appImage';
import 'blur_admin/src/app/theme/filters/image/kameleonImg';
import 'blur_admin/src/app/theme/filters/image/profilePicture';
import 'blur_admin/src/app/theme/filters/text/removeHtml';

import 'blur_admin/src/app/theme/inputs/baSwitcher/baSwitcher';

import 'blur_admin/src/app/theme/services/baProgressModal';
import 'blur_admin/src/app/theme/services/baUtil';
import 'blur_admin/src/app/theme/services/fileReader';
import 'blur_admin/src/app/theme/services/preloader';
import 'blur_admin/src/app/theme/services/stopableInterval';

/**
 * Since we don't want to use all external libraries included in BlurAdmin, we need to strip its dependency
 * injection list. `stripDependency` Does exaclty that. Given name of angular module it will try to remove it
 * from "BlurAdmin.theme" moudule dependency list.
 *
 * @function
 * @memberOf cms.BlurAdmin
 * @param name
 */
function stripDependency(name){
    let requires = angular.module("BlurAdmin.theme").requires;
    const index = requires.indexOf(name);

    if (index !== -1) {
        requires.splice(index, 1);
    }

}
stripDependency('angular-chartist');
stripDependency('textAngular');

/**
 * Now our decorators and overrides, with proper importsw
 */

import BackTopDecorator from './backTopDecorator/backTop';
import PreLoaderDecorator from './preloaderDecorator/blurAdminLoaderDecorator';
import SidebarServiceDecorator from './baSidebarDecorator/baSidebarDecorator';
import PageTopDirectiveDecorator from './baPageTopDecorator/pageTopDirectiveDecorator';
import ContentTopDecorator from './contentTopDecorator/contentTopDecorator';

/**
 * Main module for BlurAdmin related modules. Most of the time this will contain decorators for BlurAdmin
 * providers.
 *
 * @namespace cms.BlurAdmin
 */

export default angular.module('cms.blur-admin', [
    angular.module('BlurAdmin.theme').name,
    BackTopDecorator,
    SidebarServiceDecorator,
    PageTopDirectiveDecorator,
    ContentTopDecorator,
    PreLoaderDecorator
]).name;




// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/blur-admin-theme.js